let phone_id = 0;

export default {
    init() {
        this.getChangeUserPosModal();
        this.clickToButtonOnKeyboard();
        this.changeUserPos();
        this.getOrderProductsInformation();
        this.showModifierInOrder();
    },
    getChangeUserPosModal() {
        $('body').on('click', '.pos-navbar .user', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/get_change_user_pos_modal',
                success: function (response) {
                    phone_id = 0;
                    $('#change-user-pos-modal').html(response);
                    $('#change_user_pos').modal('show');
                }
            });
        });
        $('body').on('click', '#change_user_pos_form .phone-item', function (e) {
            e.preventDefault();
            phone_id = $(this).data('phone_id');
            $('#pin_modal_form')[0].reset();
            $('#pin_modal .errors').html('');
            $('#pin_modal').modal('show');
        });
    },
    clickToButtonOnKeyboard() {
        $('body').on('click', '#pin_modal .keyboard .button', function (e) {
            e.preventDefault();
            let pin = $('#pin_modal input[name="pin"]').val();
            if (pin.length < 6) {
                pin += $(this).data('value');
            }
            $('#pin_modal input[name="pin"]').val(pin);
        });
        $('body').on('click', '#pin_modal .keyboard .remove-button', function (e) {
            e.preventDefault();
            let pin = $('#pin_modal input[name="pin"]').val();
            if (pin.length > 0) {
                pin = pin.substring(0, pin.length - 1);
            }
            $('#pin_modal input[name="pin"]').val(pin);
        });
    },
    changeUserPos() {
        $('body').on('click', '#pin_modal .go-pos', function (e) {
            e.preventDefault();
            let pin = $('#pin_modal input[name="pin"]').val();
            $.ajax({
                type: 'POST',
                url: '/change_pin_pos',
                data: ({
                    pin: pin,
                    user_id: phone_id,
                }),
                success: function () {
                    location.href = '/pos';
                },
                error: function (response) {
                    $('#pin_modal .errors').html('<div class="alert alert-danger">' + response.responseJSON.error + '</div>');
                }
            });
        });
    },
    getOrderProductsInformation() {
        $('body').on('click', '#my_orders .btn-show', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/get_order_products',
                data: ({
                    order_id: $(this).data('order_id'),
                }),
                success: function (response) {
                    $('#order-products-information').html(response.view);
                    $('#order_products_modal').modal('show');
                }
            });
        });
    },
    showModifierInOrder() {
        $('body').on('click', '#order_products_modal .product_header', function (e) {
            e.preventDefault();
            if ($(this).parent().hasClass('show')) {
                $(this).parent().removeClass('show');
            } else {
                $('#order_products_modal .product.show').removeClass('show');
                $(this).parent().addClass('show');
            }
        });
    }
}
